export default __webpack_public_path__ + "static/facts-sellers-32e7be1e83a492fa3deefd7d7cc008aa.webp";